"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Form = Form;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _trackingLib = require("./tracking-lib");

var enhance = _trackingLib.withFormTracking;

function Form(_ref) {
  var action = _ref.action,
      children = _ref.children,
      className = _ref.className,
      onSubmit = _ref.onSubmit;
  return /*#__PURE__*/_react["default"].createElement("form", {
    action: action,
    className: className,
    onSubmit: onSubmit
  }, children);
}

Form.propTypes = {
  action: _propTypes["default"].string,
  children: _propTypes["default"].node,
  onSubmit: _propTypes["default"].func,
  className: _propTypes["default"].string
};

var _default = enhance(Form);

exports["default"] = _default;